import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_question.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b278f0aa")

_pushScopeId("data-v-b278f0aa")
const _hoisted_1 = { class: "mypagefoodsrankingcontent" }
const _hoisted_2 = { class: "mypagefoodsrankingcontent-contents" }
const _hoisted_3 = { class: "mypagefoodsrankingcontent-contents-userranking" }
const _hoisted_4 = { class: "commonCard mypagefoodsrankingcontent-contents-userranking-card" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "mypagefoodsrankingcontent-contents-userranking-card-leftarea" }, null, -1)
const _hoisted_6 = { class: "mypagefoodsrankingcontent-contents-userranking-card-description" }
const _hoisted_7 = { class: "mypagefoodsrankingcontent-contents-userranking-card-description-title" }
const _hoisted_8 = { class: "mypagefoodsrankingcontent-contents-userranking-card-description-title-text" }
const _hoisted_9 = { class: "mypagefoodsrankingcontent-contents-userranking-card-description-rank" }
const _hoisted_10 = { class: "mypagefoodsrankingcontent-contents-userranking-card-description-rank-text" }
const _hoisted_11 = { class: "mypagefoodsrankingcontent-contents-userranking-card-rightarea" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefoodsrankingcontent-contents-userranking-card-rightarea-button-image",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MypageFoodsRankingContentFoodsRankingCard = _resolveComponent("MypageFoodsRankingContentFoodsRankingCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.userRankingTitleText), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.rankText), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", {
              class: "mypagefoodsrankingcontent-contents-userranking-card-rightarea-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickQuestion(...args)))
            }, [
              _hoisted_12
            ])
          ])
        ])
      ]),
      _createVNode(_component_MypageFoodsRankingContentFoodsRankingCard, {
        cardTitle: _ctx.usedFoofdsRankingTitleText,
        isValidRankImage: true,
        personalFoodsRanking: _ctx.personalUsedFoodsRanking,
        nationwideFoodsRanking: _ctx.nationwideUsedFoodsRanking,
        onClickQuestion: _ctx.clickQuestion,
        onClickArea: _ctx.clickUsedArea
      }, null, 8, ["cardTitle", "personalFoodsRanking", "nationwideFoodsRanking", "onClickQuestion", "onClickArea"]),
      _createVNode(_component_MypageFoodsRankingContentFoodsRankingCard, {
        cardTitle: _ctx.disposedFoofdsRankingTitleText,
        isValidRankImage: false,
        personalFoodsRanking: _ctx.personalDisposedFoodsRanking,
        nationwideFoodsRanking: _ctx.nationwideDisposedFoodsRanking,
        onClickQuestion: _ctx.clickQuestion,
        onClickArea: _ctx.clickDisposedArea
      }, null, 8, ["cardTitle", "personalFoodsRanking", "nationwideFoodsRanking", "onClickQuestion", "onClickArea"])
    ])
  ]))
})